'use client';

import { envHasDevFlagsEnabled } from '../util/envHasDevFlagsEnabled';
import { useDevFlags } from './useDevFlags';
import { LDFlagSet } from 'launchdarkly-js-sdk-common';
import { useFlags as useSDKFlags } from 'launchdarkly-react-client-sdk';

/**
 * This hook is used to get the feature flags from LaunchDarkly.
 *
 * It uses a proxy to override the feature flags in development mode which is set
 * via the `NEXT_PUBLIC_LAUNCH_DARKLY_DEVELOPMENT_FLAGS_ENABLED` environment variable.
 * The proxy will check if the feature flag is set in the cookies or in the URL.
 * If it is, it will return the value from the URL first or from the cookies.
 * If not, it will return the value from LaunchDarkly.
 *
 * @returns {T} - The feature flags from LaunchDarkly.
 */
export function useFlags<T extends LDFlagSet>(): ReturnType<
  typeof useSDKFlags<T>
> {
  const flags = useSDKFlags<T>();
  const devFlags = useDevFlags<T>();

  return envHasDevFlagsEnabled() ? devFlags : flags;
}
